import { useTranslation } from 'react-i18next';
import { useCurrentSite } from '@hotjar/site';
import { SITE } from '@hotjar/webapp/constants/routes';
import { getRoute } from '@hotjar/webapp/utils/routing';
import { usePermission } from '@hotjar/webapp/domains/authorization';
import { useTrackingStatusTrack } from '../hooks/useTrack';
import { Alert } from './Alert';
import { SiteUrl } from './SiteUrl';

export function DisabledState({
  trackingUIPosition,
}: {
  trackingUIPosition?: string;
}): JSX.Element {
  const { data: currentSite } = useCurrentSite();
  const url = currentSite?.url;
  const { t } = useTranslation();
  const { trackClick } = useTrackingStatusTrack();
  const hasSiteUpdatePermission = usePermission('sites-update');

  return (
    <>
      {url ? <SiteUrl url={url} /> : null}
      <Alert
        kind="warning"
        actionText={
          hasSiteUpdatePermission
            ? t('activation:dashboard.status-card.edit-session-capture-settings')
            : undefined
        }
        actionHref={
          currentSite && hasSiteUpdatePermission
            ? getRoute(SITE.SETTINGS.path, {
                siteId: currentSite.id,
                '#': 'targeting',
              })
            : undefined
        }
        onClick={() => trackClick('Enable Session Capture', trackingUIPosition)}
        direction="column"
      >
        {t('activation:dashboard.status-card.spaces-capture-disabled')}
      </Alert>
    </>
  );
}
